/** @module SiteAdmin/AvailableCrewRoleUsersTable */
define([
    "dojo/_base/declare",
    "csi",
    "csi/table/Widget",
    "csi/xml",
    "csi/xml/Query"
], function(declare,csi,Widget,xml,Query) {
    return declare(Widget, {

        /**
         * @override
         * Display local users when adding Role User on Supplier
         */
        onCreateMainQueryLevel: function(ql) {
            if(this.getViewNode().$Type != "Supplier"){
                ql.serverQuery = 
                    new Query().RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, csi.EMPTY_URL);
            } else {
                const q = new Query();
                const crewHolder = this.cacheView.getNode(this.urlRoot);
                // isForAssignedAgentCrew is set in AggregateCrewRoleusers.js Controller
                const crew = this.isForAssignedAgentCrew ? crewHolder.AssignedAgentCrew : crewHolder.Crew;
                q.Or().RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, crew)
                                    .RefAttr(xml.ATTR_PARENT, xml.OP_EQUALS, csi.EMPTY_URL);
                ql.serverQuery = q;
            }
        }
    });
});